import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getColor } from '@/helpers/utils';
import { useState } from 'react';
import type { ReactNode } from 'react';
import { Spinner } from 'react-bootstrap';
import { AiOutlineZoomIn } from 'react-icons/ai';
import {
  MdCheck,
  MdContentCopy,
  MdOutlineOpenInNew
} from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { errorMessage } from '@/utils/toast';

// نمایش لینک هایی که خود لینک هستن در حدول
type URLRendererWithLinkProps = {
  url: string;
  job_page?: string | number | null;
  status_code?: string | number | null;
  onDetails?: () => void;
  details?: string;
  disabled?: boolean;
  activeTab?: string;
  to: string;
  children?: ReactNode;
};

const URLRendererWithLink = ({
  url,
  job_page,
  status_code,
  details = '',
  disabled = false,
  activeTab = '',
  to
}: URLRendererWithLinkProps) => {
  const [copied, setCopied] = useState(false);
  const [openerClicked, setopenerClicked] = useState(false);
  const [, setSearchParams] = useSearchParams();
  // نحوه نمایش لینک https یا https
  try {
    url = decodeURIComponent(url).toLowerCase();
  } catch (error) {
    console.log('Error in decode URI URLRenderer.');
  }
  const urlFormater = () => {
    if (url?.startsWith('https://'))
      return (
        <>
          <FontAwesomeIcon
            size="sm"
            icon={'lock'}
            title="https"
            color={getColor('success')}
          />
          {url.replace('https://', '')}
        </>
      );
    else if (url?.startsWith('http://'))
      return (
        <>
          <FontAwesomeIcon
            size="sm"
            icon={'lock-open'}
            title="http"
            color={getColor('danger')}
          />
          {url.replace('http://', '')}
        </>
      );
    else {
      return <div></div>;
    }
  };

  return (
    <div className="text-end w-100 text-900" style={{ direction: 'ltr' }}>
      {url && url !== 'http://' && url !== 'https://' && (
        <>
          <Link
            to={to}
            style={{
              color: getColor('navbar-vertical-default-link-active-color')
            }}
            className={`fw-bolder btn-link ${disabled && 'disabled-link'}`}
          >
            <div className="d-flex gap-1 align-items-baseline">
              {urlFormater()}
            </div>
          </Link>
          <div
            id="UrlMenu"
            className="position-absolute pe-3 ps-2 opacity-100 top-50 start-0 d-flex gap-1 align-items-center justify-content-center"
            style={{
              zIndex: 6000,
              transform: 'translate(0,-65%)',
              height: 30
            }}
          >
            {copied ? (
              <MdCheck size={18} />
            ) : (
              <MdContentCopy
                title="کپی پیوند"
                onClick={() => {
                  navigator.clipboard.writeText(url).then(() => {
                    setCopied(true);
                    setTimeout(() => {
                      setCopied(false);
                    }, 3000);
                  });
                }}
                className="cursor-pointer little-icon"
                style={{ paddingLeft: '3px' }}
                size={18}
              />
            )}

            <MdOutlineOpenInNew
              title="بازکردن پیوند"
              onClick={() => {
                try {
                  window.open(url, '_blank');
                } catch (error) {
                  errorMessage('.پیوند قابل بازکردن نمی‌باشد');
                  console.error('خطا در بازکردن پیوند:', error);
                }
              }}
              className="cursor-pointer little-icon"
              style={{ paddingLeft: '3px' }}
              size={18}
            />
            {openerClicked ? (
              <Spinner
                animation="border"
                style={{
                  width: '18px',
                  marginBottom: '-3px',
                  paddingLeft: '3px',
                  height: '18px'
                }}
              />
            ) : (
              <>
                {activeTab && (
                  <AiOutlineZoomIn
                    title="جزئیات نشانی"
                    onClick={() => {
                      setSearchParams({
                        details: details ?? '',
                        activeTab,
                        page_url: url,
                        job_page: job_page == null ? '' : String(job_page),
                        status_code:
                          status_code == null ? '' : String(status_code)
                      });
                      setopenerClicked(true);
                      setTimeout(() => {
                        setopenerClicked(false);
                      }, 3000);
                    }}
                    className="cursor-pointer little-icon"
                    style={{ paddingLeft: '3px' }}
                    size={18}
                  />
                )}
              </>
            )}
          </div>
          <style>{`
    #UrlMenu {
      display:none !important;
    }
    .ag-row-hover #UrlMenu {
      display: initial !important;
      background-color: var(--ag-column-hover-color)!important;
    }
    .ag-row-selected #UrlMenu {
      display: none !important;
      background-color:var(--ag-selected-row-background-color);
    }

    .ag-row-hover.ag-row-selected #UrlMenu{
      display: initial !important;
      background-color: var(--ag-row-hover-color);
      background-image: linear-gradient(var(--ag-selected-row-background-color), var(--ag-selected-row-background-color));        
    }
    `}</style>
        </>
      )}
    </div>
  );
};

export default URLRendererWithLink;
